exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1T6dYaKmqChizQUWzuhg7F ._1G7IcwIT5UwsBkhiPshNyC{position:absolute;top:0;left:0;height:6px}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_1T6dYaKmqChizQUWzuhg7F",
	"scroll-decoration": "_1G7IcwIT5UwsBkhiPshNyC"
};